"use client"

import { useState, useEffect, useCallback } from "react"
import { useNavigate } from "react-router-dom"
import Cookies from "js-cookie"
import OuterFrame from "../../common/OuterFrame"
import { Oval } from "react-loader-spinner"
import "./index.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import SidebarOverlay from "../../Sidebar"
import ConcentForm from "../../common/PaitentConcent"
import {
  faUser,
  faRuler,
  faEnvelope,
  faMapMarkerAlt,
  faPhone,
  faIdBadge,
  faBirthdayCake,
  faVenusMars,
  faWeight,
  faBalanceScale,
  faHeartbeat,
  faArrowUp,
  faArrowDown,
  faLungs,
  faFlask,
  faDna,
  faHeartPulse,
  faTint,
  faVials,
  faMicroscope,
  faVial,
  faDroplet,
  faBone,
  faCircle,
  faCube,
  faAtom,
  faWaveSquare,
  faPills,
  faThermometer,
} from "@fortawesome/free-solid-svg-icons"
import PopupContainer from "../../PopupContainer"

const CKDDetailsPage = (props) => {
  const navigate = useNavigate()
  const [loaderstatus, setLoaderStatus] = useState(true)
  const [isDataReady, setIsDataReady] = useState(false)
  const [patientInfo, setPatientInfo] = useState({})

  const [selectedOptions, setSelectedOptions] = useState({})
  const [subOptionValues, setSubOptionValues] = useState({})
  const [formData, setFormData] = useState({})
  const [warningMessage, setWarningMessage] = useState("")
  const [validationErrors, setValidationErrors] = useState({})
  const [activeId, setActiveId] = useState(null)
  const [isChecked1, setIsChecked1] = useState(false)
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const [diabetesCondition, setDiabetesCondition] = useState("")

  const [showEgfrModal, setShowEgfrModal] = useState(false)
  const [calculatedEgfr, setCalculatedEgfr] = useState(null)
  const [creatinineTimeout, setCreatinineTimeout] = useState(null)

  const calculateEgfr = (creatinine, age, gender, black = 0) => {
   
    if (!creatinine || !age || !gender) return null

    const creatVal = Number.parseFloat(creatinine)
    const ageVal = Number.parseInt(age)

    let egfr

    if (gender.toLowerCase() === "female") {
      const alpha = -0.329
      const k = 0.7

      egfr =
        141 *
        Math.pow(Math.min(creatVal / k, 1), alpha) *
        Math.pow(Math.max(creatVal / k, 1), -1.209) *
        Math.pow(0.993, ageVal) *
        1.018 // female factor

      if (black === 1) egfr *= 1.159
    } else {
      const alpha = -0.411
      const k = 0.9

      egfr =
        141 *
        Math.pow(Math.min(creatVal / k, 1), alpha) *
        Math.pow(Math.max(creatVal / k, 1), -1.209) *
        Math.pow(0.993, ageVal)

      if (black === 1) egfr *= 1.159
    }

    return Math.round(egfr * 100) / 100
  }

  const validateEmail = (email) => {
    if (!email) return true // Allow empty if not required
    const emailRegex = /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/
    const trimmed = String(email).trim()
    return emailRegex.test(trimmed) && !trimmed.includes("..")
  }

  const validatePhoneNumber = (phone) => {
    if (!phone) return true // Allow empty if not required
    // Accepts: 9876543210 or +919876543210 (10 digits after optional +91)
    const phoneRegex = /^(\+91)?[6-9]\d{9}$/
    return phoneRegex.test(phone.replace(/\s/g, ""))
  }

  // Lab fields that must be whole numbers: ALP, ALT, AST, GGT, Platelet Count.
  // All other lab values (albumin, urea, creatinine, HbA1c, etc.) accept decimals.
  const INTEGER_FIELD_PATTERNS = [
    /(^|_)alkaline_phosphatase(_|$)/,
    /(^|_)alp(_|$)/,
    /(^|_)(alt|sgpt)(_|$)/,
    /(^|_)(ast|sgot)(_|$)/,
    /(^|_)ggt(_|$)/,
    /(^|_)platelet/,
  ]
  const isIntegerField = (...labels) =>
    labels.some((label) => {
      if (!label) return false
      const normalized = String(label).toLowerCase().replace(/[^a-z0-9]+/g, "_")
      return INTEGER_FIELD_PATTERNS.some((re) => re.test(normalized))
    })

  const validateRange = (value, ranges) => {
    if (!value || !ranges || ranges.length < 2) return true
    const numValue = Number.parseFloat(value)
    if (isNaN(numValue)) return false
    return numValue >= ranges[0] && numValue <= ranges[1]
  }

  const handleInputChange = (fieldName, value) => {
    if (value < 0) {
      return
    }

    // Just update the value, validate on blur
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }))

    // Special handling for creatinine with debounced eGFR calculation
    if (fieldName.toLowerCase().includes("creatinine_serum") && value) {
      if (!formData.age || !formData.gender) {
        alert("Please enter Age and Gender first before entering Creatinine value for eGFR calculation.")
        setFormData((prev) => ({
          ...prev,
          [fieldName]: "",
        }))
        return
      }

      if (creatinineTimeout) {
        clearTimeout(creatinineTimeout)
      }

      const newTimeout = setTimeout(() => {
        const egfr = calculateEgfr(value, formData.age, formData.gender)
        if (egfr) {
          if (egfr <= 15) {
            alert("eGFR value is too low (≤15). Please check the creatinine value.")
            return
          }

          setFormData((prev) => ({
            ...prev,
            egfr: egfr,
          }))
          setCalculatedEgfr(egfr)
          setShowEgfrModal(true)
        }
      }, 1000)

      setCreatinineTimeout(newTimeout)
    }
  }

  const handleInputBlur = (fieldName, value) => {
    // Skip validation for BMI (auto-calculated field)
    if (fieldName === "bmi" || fieldName === "BMI") {
      return
    }

    // Find field configuration
    let fieldConfig = null

    // Search in Patient_Details
    if (patientInfo.Patient_Details) {
      fieldConfig = patientInfo.Patient_Details.find((f) => f.key === fieldName)
    }

    // Search in Attributes if not found
    if (!fieldConfig && patientInfo.Attributes) {
      for (const attrGroup of patientInfo.Attributes) {
        const groupKey = Object.keys(attrGroup)[0]
        const fields = attrGroup[groupKey]
        fieldConfig = fields.find((f) => f.key === fieldName)
        if (fieldConfig) break
      }
    }

    if (fieldName === "diabetes_test_value" && formData.diabetes) {
      const diabetesField = patientInfo.Attributes?.[1]?.["Medical History"]?.find((f) => f.key === "diabetes")

      if (diabetesField) {
        const selectedOption = diabetesField.options.find((opt) => opt.name === formData.diabetes)

        if (selectedOption && selectedOption.sub_options) {
          const valueSubOption = selectedOption.sub_options.find((sub) => sub.key === "diabetes_test_value")

          if (valueSubOption && valueSubOption.ranges) {
            if (value && !validateRange(value, valueSubOption.ranges)) {
              setValidationErrors((prev) => ({
                ...prev,
                [fieldName]: `Value must be between ${valueSubOption.ranges[0]} and ${valueSubOption.ranges[1]}`,
              }))
              // Auto-erase out of range value on blur
              setFormData((prev) => ({
                ...prev,
                [fieldName]: "",
              }))
              return
            } else {
              setValidationErrors((prev) => {
                const newErrors = { ...prev }
                delete newErrors[fieldName]
                return newErrors
              })
            }
          }
        }
      }
    }

    // Email validation
    if (fieldName.toLowerCase().includes("email")) {
      if (value && !validateEmail(value)) {
        setValidationErrors((prev) => ({
          ...prev,
          [fieldName]: "Please enter a valid email address (e.g., user@example.com)",
        }))
      } else {
        setValidationErrors((prev) => {
          const newErrors = { ...prev }
          delete newErrors[fieldName]
          return newErrors
        })
      }
      return
    }

    // Phone number validation
    if (fieldName.toLowerCase().includes("phone")) {
      if (value && !validatePhoneNumber(value)) {
        setValidationErrors((prev) => ({
          ...prev,
          [fieldName]: "Please enter a valid phone number (10 digits, optionally starting with +91)",
        }))
        // Auto-erase invalid phone number on blur
        setFormData((prev) => ({
          ...prev,
          [fieldName]: "",
        }))
      } else {
        setValidationErrors((prev) => {
          const newErrors = { ...prev }
          delete newErrors[fieldName]
          return newErrors
        })
      }
      return
    }

    // Range / integer validation for numeric fields
    if (fieldConfig && fieldConfig.type === "number") {
      const mustBeInteger =
        fieldName.toLowerCase() === "age" || isIntegerField(fieldConfig.key, fieldConfig.name)
      const notInteger = mustBeInteger && value && !Number.isInteger(Number(value))
      const outOfRange = fieldConfig.ranges && value && !validateRange(value, fieldConfig.ranges)
      if (notInteger || outOfRange) {
        setValidationErrors((prev) => ({
          ...prev,
          [fieldName]: notInteger
            ? `${fieldConfig.name || "Value"} must be a whole number (no decimals)`
            : `Value must be between ${fieldConfig.ranges[0]} and ${fieldConfig.ranges[1]}`,
        }))
        // Auto-erase out of range value on blur
        setFormData((prev) => ({
          ...prev,
          [fieldName]: "",
        }))
      } else {
        setValidationErrors((prev) => {
          const newErrors = { ...prev }
          delete newErrors[fieldName]
          return newErrors
        })
      }
    }
  }

  const handleEgfrChange = () => {
    setShowEgfrModal(false)
    setCalculatedEgfr(null)
    const creatinineKey = Object.keys(formData).find((key) => key.toLowerCase().includes("creatinine_serum"))
    if (creatinineKey) {
      setFormData((prev) => ({
        ...prev,
        [creatinineKey]: "",
        egfr: "",
      }))
    }
  }

  const handleEgfrProceed = () => {
    setShowEgfrModal(false)
    setCalculatedEgfr(null)
  }

  const getIconForField = (fieldName) => {
    const name = fieldName.toLowerCase()

    // Kidney-related tests
    if (name.includes("creatinine_serum")) return faTint
    if (name.includes("urea") || name.includes("bun")) return faDroplet

    // Blood chemistry
    if (name.includes("albumin")) return faVial
    if (name.includes("protein")) return faVials
    if (name.includes("hemoglobin")) return faHeartPulse
    if (name.includes("bilirubin")) return faVials
    if (name.includes("potassium")) return faAtom
    if (name.includes("sodium")) return faCube
    if (name.includes("calcium")) return faBone
    if (name.includes("phosphate")) return faCircle
    if (name.includes("magnesium")) return faWaveSquare
    if (name.includes("chloride")) return faThermometer

    // Enzymes
    if (name.includes("phosphatase")) return faMicroscope
    if (name.includes("alt") || name.includes("sgpt")) return faMicroscope
    if (name.includes("ast") || name.includes("sgot")) return faHeartbeat
    if (name.includes("ggt")) return faFlask

    // Other tests
    if (name.includes("uric")) return faDna
    if (name.includes("platelet")) return faCircle
    if (name.includes("hba1c")) return faPills

    // Patient info
    switch (name) {
      case "email":
        return faEnvelope
      case "location":
        return faMapMarkerAlt
      case "phone":
        return faPhone
      case "uhid":
      case "patient_id":
        return faIdBadge
      case "name":
        return faUser
      case "age":
        return faBirthdayCake
      case "gender":
        return faVenusMars
      case "height":
        return faRuler
      case "weight":
        return faWeight
      case "bmi":
        return faBalanceScale
      case "heart rate":
        return faHeartbeat
      case "systolic bp":
        return faArrowUp
      case "diastolic bp":
        return faArrowDown
      case "respiration rate":
        return faLungs
      default:
        return faFlask
    }
  }

  const isEmptyValue = (value) => {
    return value === undefined || value === null || value === ""
  }

  const validateForm = () => {
    const errors = {}
    let isValid = true

    // Validate Patient Details
    patientInfo.Patient_Details?.forEach((field) => {
      const value = formData[field.key]

      // Required field check
      if (field.required === "yes" && isEmptyValue(value)) {
        errors[field.key] = "This field is required"
        isValid = false
      }

      // Email validation
      if (field.key.toLowerCase().includes("email") && value && !validateEmail(value)) {
        errors[field.key] = "Please enter a valid email address"
        isValid = false
      }

      // Phone validation
      if (field.key.toLowerCase().includes("phone") && value && !validatePhoneNumber(value)) {
        errors[field.key] = "Please enter a valid phone number"
        isValid = false
      }

      // Range validation
      if (field.ranges && value && !validateRange(value, field.ranges)) {
        errors[field.key] = `Value must be between ${field.ranges[0]} and ${field.ranges[1]}`
        isValid = false
      }
    })

    // Validate Physical Attributes
    patientInfo.Attributes?.[0]["Physical Attributes"]?.forEach((field) => {
      const value = formData[field.key]

      // Skip BMI validation (auto-calculated)
      if (field.key === "bmi" || field.key === "BMI") {
        return
      }

      if (field.required === "yes" && isEmptyValue(value)) {
        errors[field.key] = "This field is required"
        isValid = false
      }

      if (field.ranges && value && !validateRange(value, field.ranges)) {
        errors[field.key] = `Value must be between ${field.ranges[0]} and ${field.ranges[1]}`
        isValid = false
      }
    })

    patientInfo.Attributes?.[1]["Medical History"]?.forEach((field) => {
      if (field.required === "yes" && isEmptyValue(formData[field.key])) {
        errors[field.key] = "This field is required"
        isValid = false
      }

      // Validate diabetes sub-option ranges
      if (field.key === "diabetes" && formData[field.key] && formData[field.key] !== "No") {
        const selectedOption = field.options.find((opt) => opt.name === formData[field.key])
        if (selectedOption && selectedOption.sub_options) {
          selectedOption.sub_options.forEach((subOption) => {
            const subValue = formData[subOption.key]
            if (subOption.type === "number" && subOption.ranges) {
              if (subValue && !validateRange(subValue, subOption.ranges)) {
                errors[subOption.key] = `Value must be between ${subOption.ranges[0]} and ${subOption.ranges[1]}`
                isValid = false
              }
            }
          })
        }
      }
    })

    patientInfo.Attributes?.[2]["Family History"]?.forEach((field) => {
      if (field.required === "yes" && isEmptyValue(formData[field.key])) {
        errors[field.key] = "This field is required"
        isValid = false
      }
    })

    // Validate Lab History with ranges
    patientInfo.Attributes?.[3]["Lab History"]?.forEach((field) => {
      const value = formData[field.key]

      if (field.required === "yes" && isEmptyValue(value)) {
        errors[field.key] = "This field is required"
        isValid = false
      }

      if (value && isIntegerField(field.key, field.name) && !Number.isInteger(Number(value))) {
        errors[field.key] = `${field.name} must be a whole number (no decimals)`
        isValid = false
      } else if (field.ranges && value && !validateRange(value, field.ranges)) {
        errors[field.key] = `Value must be between ${field.ranges[0]} and ${field.ranges[1]}`
        isValid = false
      }
    })

    setValidationErrors(errors)
    return isValid
  }

  const toggleSidebar = (id) => {
    setActiveId(activeId === id ? null : id)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    setWarningMessage("")
    if (!validateForm()) {
      setWarningMessage("Please fill in all required fields correctly and ensure all values are within the valid range")
      return
    } else {
      const transformedData = transformFormDataForSubmission(formData)
      props.form_details && props.form_details(transformedData)
      navigate(`/ckd/report`)
    }
  }

  const transformFormDataForSubmission = (data) => {
    const transformed = { ...data }

    // Helper function to capitalize first letter (for Yes/No, Male/Female)
    const capitalizeFirstLetter = (str) => {
      if (!str || typeof str !== "string") return str
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    }

    // Get all numeric field keys from patientInfo
    const numericFields = new Set()

    // Add numeric fields from Patient_Details
    patientInfo.Patient_Details?.forEach((field) => {
      if (field.type === "number") {
        numericFields.add(field.key)
      }
    })

    // Add numeric fields from Attributes
    patientInfo.Attributes?.forEach((attrGroup) => {
      const groupKey = Object.keys(attrGroup)[0]
      const fields = attrGroup[groupKey]
      fields?.forEach((field) => {
        if (field.type === "number") {
          numericFields.add(field.key)
        }
        // Check for sub-options with numeric types (like diabetes test values)
        if (field.options) {
          field.options.forEach((option) => {
            if (option.sub_options) {
              option.sub_options.forEach((subOption) => {
                if (subOption.type === "number") {
                  numericFields.add(subOption.key)
                }
              })
            }
          })
        }
      })
    })

    // Transform each field
    Object.keys(transformed).forEach((key) => {
      const value = transformed[key]

      // Skip empty values
      if (value === "" || value === null || value === undefined) {
        delete transformed[key]
        return
      }

      // Convert numeric fields from string to number
      if (numericFields.has(key)) {
        const numValue = Number.parseFloat(value)
        if (!isNaN(numValue)) {
          transformed[key] = numValue
        }
      }

      // Capitalize Yes/No and Male/Female values
      if (typeof value === "string") {
        const lowerValue = value.toLowerCase()
        if (lowerValue === "yes" || lowerValue === "no") {
          transformed[key] = capitalizeFirstLetter(value)
        } else if (lowerValue === "male" || lowerValue === "female") {
          transformed[key] = capitalizeFirstLetter(value)
        }
      }
    })

    return transformed
  }

  const handleOptionChange = (key, value) => {
    setSelectedOptions((prev) => ({ ...prev, [key]: value }))
    setFormData((prev) => ({ ...prev, [key]: value }))

    if (value && value !== "") {
      setValidationErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[key]
        return newErrors
      })
    }
  }

  const handleMainOptionChange = (key, value) => {
    setSelectedOptions((prevSelectedOptions) => {
      const updatedOptions = {
        ...prevSelectedOptions,
        [key]: value,
      }
      return updatedOptions
    })

    setFormData((prevAttributeValues) => {
      const updatedValues = {
        ...prevAttributeValues,
        [key]: value,
      }
      return updatedValues
    })

    if (value && value !== "") {
      setValidationErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[key]
        return newErrors
      })
    }
  }

  const handleSubOptionChange = (parentKey, subKey, value, type) => {
    if (type === "number" && value < 0) {
      return
    }

    setSubOptionValues((prev) => ({
      ...prev,
      [parentKey]: { ...prev[parentKey], [subKey]: value },
    }))
    setFormData((prev) => ({
      ...prev,
      [subKey]: value,
    }))

    if (parentKey === "diabetes" && type === "number") {
      updateDiabetesYesValue(parentKey, value)
    }
  }

  const handleCheckboxChangeForForm = (key, value) => {
    setFormData((prevAttributeValues) => {
      const currentValues = prevAttributeValues[key] || []
      let newValues

      if (value === "None") {
        newValues = ["None"]
      } else {
        const filteredValues = currentValues.filter((v) => v !== "None")

        newValues = filteredValues.includes(value)
          ? filteredValues.filter((v) => v !== value)
          : [...filteredValues, value]
      }

      const updatedValues = {
        ...prevAttributeValues,
        [key]: newValues,
      }
      return updatedValues
    })
  }

  useEffect(() => {
    const initializeData = async () => {
      setLoaderStatus(true)
      try {
        const jwt_token = Cookies.get("jwt_token")
        const myHeaders = new Headers()
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("Authorization", `Bearer ${jwt_token}`)

        const options = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow",
        }

        const url = props.LANDING_URL || "https://clinical-server-apis.azurewebsites.net/fields/ckd"
        const response = await fetch(url, options)
        const responseObj = await response.json()

        if (responseObj.status === "success") {
          setPatientInfo(responseObj.data)
          setIsDataReady(true)
          localStorage.setItem("fields", JSON.stringify(responseObj.data))
        } else {
          const savedContent = JSON.parse(localStorage.getItem("fields"))
          if (savedContent) {
            setPatientInfo(savedContent)
            setIsDataReady(true)
          }
        }
      } catch (error) {
        console.error("Error fetching CKD data from API, falling back to localStorage:", error)
        const savedContent = JSON.parse(localStorage.getItem("fields"))
        if (savedContent) {
          setPatientInfo(savedContent)
          setIsDataReady(true)
        }
      } finally {
        setTimeout(() => {
          setLoaderStatus(false)
        }, 500)
      }
    }

    initializeData()
  }, [props.app, props.LANDING_URL])

  const calculateBMI = useCallback((height, weight) => {
    if (height && weight) {
      let bmi = weight / Math.pow(height * 0.01, 2)
      const decimal = bmi - Math.floor(bmi)
      bmi = Math.floor(bmi) + Math.floor(decimal * 100) / 100
      return bmi
    }
    return null
  }, [])

  useEffect(() => {
    const height = formData.height
    const weight = formData.weight
    if (height && weight) {
      const bmi = calculateBMI(height, weight)
      setFormData((prevValues) => {
        if (prevValues.BMI !== bmi) {
          return {
            ...prevValues,
            BMI: bmi,
          }
        }
        return prevValues
      })
    }
  }, [formData.height, formData.weight, calculateBMI])

  const updateDiabetesYesValue = (parentKey, value) => {
    let condition = ""

    // Convert to number for comparison
    const numericValue = Number.parseFloat(value)

    if (!isNaN(numericValue)) {
      if (formData[parentKey] === "Fasting Blood Sugar") {
        if (numericValue >= 126 && numericValue <= 170) {
          condition = "Controlled Blood Sugar"
        } else if (numericValue > 170) {
          condition = "Uncontrolled – High Blood Sugar"
        }
      } else if (formData[parentKey] === "HBA1c") {
        if (numericValue < 7.5) {
          condition = "Controlled Blood Sugar"
        } else {
          condition = "Uncontrolled – High Blood Sugar"
        }
      } else {
        if (numericValue >= 1.7 && numericValue <= 2.0) {
          condition = "Normal"
        } else {
          condition = "Abnormal"
        }
      }
    }

    setDiabetesCondition(condition)
  }

  const renderSubOption = (subOption, parentKey) => {
    let rangeInfo = null
    if (parentKey === "diabetes" && subOption.type === "number") {
      const diabetesField = patientInfo.Attributes?.[1]?.["Medical History"]?.find((f) => f.key === "diabetes")
      if (diabetesField) {
        const selectedOption = diabetesField.options.find((opt) => opt.name === formData.diabetes)
        if (selectedOption && selectedOption.sub_options) {
          const valueSubOption = selectedOption.sub_options.find((sub) => sub.key === subOption.key)
          if (valueSubOption && valueSubOption.ranges) {
            rangeInfo = {
              min: valueSubOption.ranges[0],
              max: valueSubOption.ranges[1],
              unit: selectedOption.units || "",
            }
          }
        }
      }
    }

    return (
      <div className="sub-option-wrapper">
        {subOption.type === "number" && (
          <div className="number-input-container">
            <label>
              {subOption.name}
              {rangeInfo && ` (${rangeInfo.min}-${rangeInfo.max}${rangeInfo.unit ? " " + rangeInfo.unit : ""})`}
            </label>
            <input
              type="number"
              min="0"
              step="any"
              placeholder={rangeInfo ? `${rangeInfo.min}-${rangeInfo.max}` : ""}
              value={subOptionValues[parentKey]?.[subOption.key] || ""}
              onChange={(e) => handleSubOptionChange(parentKey, subOption.key, e.target.value, subOption.type)}
              onBlur={(e) => handleInputBlur(subOption.key, e.target.value)}
            />
            {validationErrors[subOption.key] && (
              <span className="error-message" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                {validationErrors[subOption.key]}
              </span>
            )}
          </div>
        )}

        {subOption.type === "date" && (
          <div className="date-picker-container">
            <label>{subOption.name}</label>
            <input
              type="date"
              max={new Date().toISOString().split("T")[0]}
              value={subOptionValues[parentKey]?.[subOption.key] || ""}
              onChange={(e) => handleSubOptionChange(parentKey, subOption.key, e.target.value)}
            />
          </div>
        )}
      </div>
    )
  }

  const renderAttributes = (attributes, section) => {
    return attributes?.map((attribute, index) => (
      <div className="form-field-container" key={index}>
        <div className="form-field">
          <FontAwesomeIcon icon={getIconForField(attribute.name)} className="field-icon" />
          <input
            type={attribute.type === "number" ? "number" : "text"}
            min={attribute.type === "number" ? "0" : undefined}
            step={attribute.type === "number" ? "any" : undefined}
            placeholder=""
            value={formData[attribute.key] || ""}
            onFocus={(e) => {
              handleFieldFocus(attribute.key)
              e.target.placeholder = getPlaceholderText(attribute)
            }}
            onBlur={(e) => {
              e.target.placeholder = ""
              handleInputBlur(attribute.key, e.target.value)
            }}
            onChange={(e) => handleInputChange(attribute.key, e.target.value)}
            readOnly={attribute.key === "bmi" || attribute.key === "BMI"}
            className={`${validationErrors[attribute.key] ? "error" : ""}
                     ${attribute.key === "bmi" || attribute.key === "BMI" ? "readonly" : ""}`}
          />
          <label>
            {attribute.name} {attribute.units && `(${attribute.units})`}
            {attribute.required === "yes" && <span className="required">*</span>}
          </label>
          {attribute.description && attribute.description !== "" && (
            <span>
              <button type="button" onClick={() => toggleSidebar(attribute.name)} className="description-bar">
                i
              </button>
              {activeId === attribute.name && (
                <SidebarOverlay
                  id={attribute.name}
                  description={attribute.description}
                  activeId={activeId}
                  name={attribute.name}
                  setActiveId={setActiveId}
                  toggleSidebar={toggleSidebar}
                />
              )}
            </span>
          )}
        </div>
        {validationErrors[attribute.key] && <span className="error-message">{validationErrors[attribute.key]}</span>}
      </div>
    ))
  }
  const renderMedicalHistoryOptions = (item) => {
    if (item.type === "select" && (item.name === "Diabetes Mellitus" || item.name === "Hypertension" || item.name === "Dyslipidemia")) {
      return (
        <div className="select-group">
          <select
            name={item.key}
            value={selectedOptions[item.key] || ""}
            onChange={(e) => handleMainOptionChange(item.key, e.target.value)}
            className={validationErrors[item.key] ? "error" : ""}
          >
            <option value="">Select</option>
            {item.options.map((option, optIndex) => {
              let optionLabel = option.name
              if (option.sub_options) {
                const valueSubOption = option.sub_options.find((sub) => sub.type === "number" && sub.ranges)
                if (valueSubOption && valueSubOption.ranges) {
                  optionLabel = `${option.name} (${valueSubOption.ranges[0]}-${valueSubOption.ranges[1]} ${option.units || ""})`
                }
              }

              return (
                <option key={optIndex} value={option.name}>
                  {optionLabel}
                </option>
              )
            })}
          </select>
          {validationErrors[item.key] && (
            <span className="error-message" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
              {validationErrors[item.key]}
            </span>
          )}

          <div className={`${item.name === "Diabetes Mellitus" ? "input-date-container" : null}`}>
            {item.options.map(
              (option, optIndex) =>
                formData[item.key] === option.name &&
                option.sub_options?.map((subOption, subIndex) => (
                  <div key={subOption.value} className="">
                    <div key={subIndex} className="sub-option">
                      {subOption.type === "checkbox" ? (
                        <div className="checkbox-input-box checkbox_input_box_in_input_component">
                          <div className="checkbox-container">
                            <input
                              name={subOption.key}
                              id={`${subOption.key}_${subOption.name}`}
                              type={subOption.type}
                              value={subOption.value}
                              onChange={(event) => handleCheckboxChangeForForm(subOption.key, event.target.value)}
                              className="checkbox-input"
                              checked={formData[subOption.key] && formData[subOption.key].includes(subOption.value)}
                            />

                            <span className="custom-checkbox">
                              <img src="/checkmark-outline-white.svg" alt="checkmark-outline-white" />
                            </span>
                          </div>

                          <div className="inputbox checkbox_lable_box_input_in_input_component">
                            <label
                              className="lable_in_input_component checkbox_lable_in_input_component"
                              htmlFor={`${subOption.key}_${subOption.name}`}
                            >
                              {subOption.value}
                            </label>
                          </div>
                        </div>
                      ) : (
                        renderSubOption(subOption, item.key)
                      )}
                    </div>
                    {subOption.type === "checkbox" &&
                      formData[subOption.key]?.includes(subOption.value) &&
                      subOption.sub_options && (
                        <div className="sub-option-container">
                          {subOption.sub_options.map((subSubOption) => (
                            <div key={subSubOption.value} className="sub-option-container">
                              <div className="checkbox-input-box checkbox_input_box_in_input_component">
                                <div className="checkbox-container">
                                  <input
                                    name={subSubOption.key}
                                    id={`${subOption.key}_${subSubOption.name}`}
                                    type={subSubOption.type}
                                    value={subSubOption.value}
                                    onChange={(event) =>
                                      handleCheckboxChangeForForm(subSubOption.key, event.target.value)
                                    }
                                    className="checkbox-input"
                                    checked={
                                      formData[subSubOption.key] &&
                                      formData[subSubOption.key].includes(subSubOption.value)
                                    }
                                  />

                                  <span className="custom-checkbox">
                                    <img src="/checkmark-outline-white.svg" alt="checkmark-outline-white" />
                                  </span>
                                </div>

                                <div className="inputbox checkbox_lable_box_input_in_input_component">
                                  <label
                                    className="lable_in_input_component checkbox_lable_in_input_component"
                                    htmlFor={`${subOption.key}_${subSubOption.name}`}
                                  >
                                    {subSubOption.value}
                                  </label>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                  </div>
                )),
            )}
          </div>
          {item.name === "Diabetes Mellitus" && diabetesCondition !== "" && (
            <p className="diabetes-highlighted-text">
              Your Diabetes is
              <span
                className={`${diabetesCondition === "Controlled Blood Sugar" || diabetesCondition === "Normal"
                  ? "green-text"
                  : "red-text"
                  }`}
              >
                {diabetesCondition}
              </span>
            </p>
          )}
        </div>
      )
    }

    return (
      <div className="select-group">
        <select
          name={item.key}
          value={formData[item.key] || ""}
          onChange={(e) => handleOptionChange(item.key, e.target.value)}
          className={validationErrors[item.key] ? "error" : ""}
        >
          <option value="">Select</option>
          {item.options.map((option, optIndex) => (
            <option key={optIndex} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
        {validationErrors[item.key] && (
          <span className="error-message" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
            {validationErrors[item.key]}
          </span>
        )}
      </div>
    )
  }

  const renderMedicalHistory = (medicalHistory) => {
    const specialConditions = ["diabetes", "dyslipidemia", "hypertension"]
    const specialItems = []
    const regularItems = []

    medicalHistory?.forEach((item, index) => {
      const isSpecial = specialConditions.some((condition) => item.name.toLowerCase().includes(condition.toLowerCase()))

      if (isSpecial) {
        specialItems.push({ ...item, originalIndex: index })
      } else {
        regularItems.push({ ...item, originalIndex: index })
      }
    })

    return (
      <div>
        {/* Special conditions in 2-column layout */}
        <div className="medical-history-form-grid">
          {specialItems.map((item) => (
            <div key={item.originalIndex} className="card">
              <p>
                {item.name} {item.required === "yes" && <span className="required-asterisk">*</span>}
                {item.description && (
                  <span>
                    <button type="button" onClick={() => toggleSidebar(item.name)} className="description-bar">
                      i
                    </button>
                    {activeId === item.name && (
                      <SidebarOverlay
                        id={item.name}
                        description={item.description}
                        activeId={activeId}
                        name={item.name}
                        setActiveId={setActiveId}
                        toggleSidebar={toggleSidebar}
                      />
                    )}
                  </span>
                )}
              </p>
              {renderMedicalHistoryOptions(item)}
            </div>
          ))}
        </div>

        {/* Regular conditions in 3-column layout */}
        <div className="medical-history-three-column">
          {regularItems.map((item) => (
            <div key={item.originalIndex} className="card">
              <p>
                {item.name} {item.required === "yes" && <span className="required-asterisk">*</span>}
                {item.description && (
                  <span>
                    <button type="button" onClick={() => toggleSidebar(item.name)} className="description-bar">
                      i
                    </button>
                    {activeId === item.name && (
                      <SidebarOverlay
                        id={item.name}
                        description={item.description}
                        activeId={activeId}
                        name={item.name}
                        setActiveId={setActiveId}
                        toggleSidebar={toggleSidebar}
                      />
                    )}
                  </span>
                )}
              </p>
              {renderMedicalHistoryOptions(item)}
            </div>
          ))}
        </div>
      </div>
    )
  }

  const renderFamilyHistoryOptions = (item) => {
    return (
      <div className="select-group">
        <select
          name={item.key}
          value={formData[item.key] || ""}
          onChange={(e) => handleOptionChange(item.key, e.target.value)}
          className={validationErrors[item.key] ? "error" : ""}
        >
          <option value="">Select</option>
          {item.options.map((option, optIndex) => (
            <option key={optIndex} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
        {validationErrors[item.key] && (
          <span className="error-message" style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
            {validationErrors[item.key]}
          </span>
        )}
      </div>
    )
  }

  const renderFamilyHistory = (familyHistory) => {
    return (
      <div className="family-history-three-column">
        {familyHistory?.map((item, index) => (
          <div key={index} className="card">
            <p>
              {item.name} {item.required === "yes" && <span className="required-asterisk">*</span>}
              {item.description && (
                <span>
                  <button type="button" onClick={() => toggleSidebar(item.name)} className="description-bar">
                    i
                  </button>
                  {activeId === item.name && (
                    <SidebarOverlay
                      id={item.name}
                      description={item.description}
                      activeId={activeId}
                      name={item.name}
                      setActiveId={setActiveId}
                      toggleSidebar={toggleSidebar}
                    />
                  )}
                </span>
              )}
            </p>
            {renderFamilyHistoryOptions(item)}
          </div>
        ))}
      </div>
    )
  }

  const renderLabHistory = (attributes) => {
    return attributes?.map((attribute, index) => (
      <div className="form-field-container" key={index}>
        <div className="form-field">
          <FontAwesomeIcon icon={getIconForField(attribute.name)} className="field-icon" />
          <input
            type="number"
            min="0"
            step={isIntegerField(attribute.key, attribute.name) ? "1" : "any"}
            placeholder=""
            value={formData[attribute.key] || ""}
            onKeyDown={(e) => {
              // Integer-only fields: block decimal point and exponent
              if (isIntegerField(attribute.key, attribute.name) && [".", ",", "e", "E"].includes(e.key)) {
                e.preventDefault()
              }
            }}
            onFocus={(e) => {
              handleFieldFocus(attribute.key)
              e.target.placeholder = getPlaceholderText(attribute)
            }}
            onBlur={(e) => {
              e.target.placeholder = ""
              handleInputBlur(attribute.key, e.target.value)
            }}
            onChange={(e) => handleInputChange(attribute.key, e.target.value)}
            className={validationErrors[attribute.key] ? "error" : ""}
          />
          <label>
            {attribute.name} {attribute.units && `(${attribute.units})`}
            {attribute.required === "yes" && <span className="required">*</span>}
          </label>
          {attribute.description && attribute.description !== "" && (
            <span>
              <button type="button" onClick={() => toggleSidebar(attribute.name)} className="description-bar">
                i
              </button>
              {activeId === attribute.name && (
                <SidebarOverlay
                  id={attribute.name}
                  description={attribute.description}
                  activeId={activeId}
                  name={attribute.name}
                  setActiveId={setActiveId}
                  toggleSidebar={toggleSidebar}
                />
              )}
            </span>
          )}
        </div>
        {validationErrors[attribute.key] && <span className="error-message">{validationErrors[attribute.key]}</span>}
      </div>
    ))
  }

  const handleFieldFocus = (key) => {
    // Format errors (email/phone) must persist until the value is actually fixed
    if (/e-?mail|phone/i.test(key)) return
    if (validationErrors[key]) {
      setValidationErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[key]
        return newErrors
      })
    }
  }

  const getPlaceholderText = (field) => {
    if (field.ranges) {
      return `${field.ranges[0]} - ${field.ranges[1]}`
    }
    return ""
  }

  const openPopup = () => setIsPopupOpen(true)

  const closePopup = () => setIsPopupOpen(false)

  return (
    <OuterFrame
      hightlight="2"
      appName={"AICKD"}
      doc_name="ckd"
      color={props.color}
      secondaryColor={props.secondaryColor}
      surface_color={props.surface_color}
      surface_highlight_color={props.surface_highlight_color}
      surface_hover_color={props.surface_hover_color}
      button_hover_color={props.button_hover_color}
      component={
        loaderstatus || !isDataReady ? (
          <div className="loader-container">
            <Oval
              height={80}
              width={80}
              color="#4fa94d"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="#4fa94d"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="medical-form">
            <div className="form-sections">
              <section className="basic-info">
                <h2 className="patient-medical-info-heading">Basic Information</h2>
                <div className="form-grid">
                  {patientInfo?.Patient_Details?.map((patient, index) => (
                    <div key={index} className="form-field-container">
                      <div className="form-field">
                        <FontAwesomeIcon icon={getIconForField(patient.name)} className="field-icon" />
                        {patient.key === "gender" ? (
                          <select
                            value={formData.gender || ""}
                            onChange={(e) => handleInputChange("gender", e.target.value)}
                            onFocus={() => handleFieldFocus(patient.key)}
                            className="gender-select"
                          >
                            <option value="" disabled>
                              Select Gender *
                            </option>
                            {patient.options?.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <>
                            <input
                              type={patient.type === "number" ? "number" : "text"}
                              min={patient.type === "number" ? "0" : undefined}
                              step={patient.type === "number" ? (patient.key === "age" ? "1" : "any") : undefined}
                              placeholder=""
                              value={formData[patient.key] || ""}
                              onFocus={(e) => {
                                handleFieldFocus(patient.key)
                                e.target.placeholder = getPlaceholderText(patient)
                              }}
                              onBlur={(e) => {
                                e.target.placeholder = ""
                                handleInputBlur(patient.key, e.target.value)
                              }}
                              onChange={(e) => handleInputChange(patient.key, e.target.value)}
                            />
                            <label>
                              {patient.name} {patient.required === "yes" && <span className="required">*</span>}
                            </label>
                          </>
                        )}
                      </div>
                      {validationErrors[patient.key] && (
                        <span className="error-message">{validationErrors[patient.key]}</span>
                      )}
                    </div>
                  ))}
                </div>
              </section>

              <section className="physical-attributes">
                <h2 className="patient-medical-info-heading">Physical Attributes</h2>
                <div className="form-grid">
                  {renderAttributes(patientInfo?.Attributes?.[0]?.["Physical Attributes"])}
                </div>
              </section>

              <section className="medical-history">
                <h2 className="patient-medical-info-heading">Medical History</h2>
                {renderMedicalHistory(patientInfo?.Attributes?.[1]?.["Medical History"])}
              </section>

              <section className="family-history">
                <h2 className="patient-medical-info-heading">Family History</h2>
                {renderFamilyHistory(patientInfo?.Attributes?.[2]?.["Family History"])}
              </section>

              <section className="lab-history">
                <h2 className="patient-medical-info-heading">Lab History</h2>
                <div className="form-grid">{renderLabHistory(patientInfo?.Attributes?.[3]?.["Lab History"])}</div>
              </section>

              <div className="showConcentDiv">
                <span className="DocLogoForConcentButton" onClick={openPopup}>
                  <img src="/doc-icon.svg" className="consent-icon" alt="consent-icon" />
                </span>
                <button className="showConcentButton" onClick={openPopup} type="button">
                  PATIENT INFORMATION SHEET AND INFORMED CONSENT
                </button>
              </div>

              <div className="checkBoxForTC">
                <div className="checkbox-for-patient-consent">
                  <div className="checkbox-container">
                    <input
                      type="checkbox"
                      className="checkbox-input"
                      id="loginCheckBox1"
                      checked={isChecked1}
                      onChange={() => setIsChecked1((prev) => !prev)}
                    />
                    <span className="custom-checkbox">
                      <img src="/checkmark-outline-white.svg" alt="checkmark-outline-white" />
                    </span>
                  </div>
                  <label htmlFor="loginCheckBox1" className="patient-consent-label-content">
                    Patient has read and understood the information sheet, had the opportunity to ask questions, and
                    agreed to participate in the CKD Risk Assessment at Apollo Hospitals.
                  </label>
                </div>
              </div>
            </div>

            {warningMessage !== "" ? <p className="all-fields-warning-msg">{warningMessage}</p> : null}

            <div className="submit-button-container">
              <button
                type="submit"
                className="submit-button"
                disabled={!isChecked1}
                style={{
                  opacity: !isChecked1 ? 0.5 : 1,
                  cursor: !isChecked1 ? "not-allowed" : "pointer",
                }}
              >
                Submit
              </button>
            </div>

            <PopupContainer isOpen={isPopupOpen} onClose={closePopup} title="STUDY PARTICIPANT INFORMATION SHEET">
              <ConcentForm data={patientInfo.patient_consent} />
            </PopupContainer>

            {showEgfrModal && (
              <div
                className="modal-overlay"
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 1000,
                }}
              >
                <div
                  className="modal-content"
                  style={{
                    backgroundColor: "white",
                    padding: "30px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                    maxWidth: "400px",
                    width: "90%",
                    textAlign: "center",
                  }}
                >
                  <h2 style={{ marginBottom: "20px", color: "#333" }}>eGFR Calculation</h2>
                  <p
                    style={{
                      marginBottom: "20px",
                      fontSize: "18px",
                    }}
                  >
                    The calculated eGFR value is
                    <strong style={{ color: "#004b66" }}> {calculatedEgfr} mL/min/1.73m²</strong>
                  </p>
                  <p
                    style={{
                      marginBottom: "20px",
                      fontSize: "18px",
                    }}
                  >
                    Would you like to proceed with this value?
                  </p>

                  <div
                    style={{
                      display: "flex",
                      gap: "15px",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      onClick={handleEgfrChange}
                      style={{
                        padding: "10px 20px",
                        backgroundColor: "#6c757d",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      Change Creatinine Value
                    </button>
                    <button
                      onClick={handleEgfrProceed}
                      style={{
                        padding: "10px 20px",
                        backgroundColor: "#004b66",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            )}
          </form>
        )
      }
    />
  )
}

export default CKDDetailsPage
